export default "__VITE_ASSET__Br$_e80O__"